import { InjectionToken } from '@angular/core';
import { IdleInterruptSource } from './core/interrupt/interrupt-source';
import { DEFAULT_INTERRUPT_SOURCES } from './core/interrupt/source/interrupt-sources-default';

export const IDLE_OPTIONS = new InjectionToken<NIdle.IModuleOptions>('IDLE_OPTIONS');

export namespace NIdle {
    /**
     * Global Idle configuration
     */
    export interface IModuleOptions {
        enabled: boolean;
        /**
         * How long can they be inactive before considered idle, in seconds
         */
        idle: number;
        /**
         * How long can they be idle before considered timed out, in seconds
         */
        timeout: number;
        /**
         * Desired auto resume behavior.
         */
        autoResume: EAutoResume;
        /**
         * Provide sources that will "interrupt" aka provide events indicating the user is active
         */
        interrupts: IdleInterruptSource[];
        /**
         * Will ping at this interval while not idle, in seconds
         * Set `0` to disable.
         */
        pingInterval: number;
        /**
         * Will ping at this interval while idle, in seconds
         * Set `0` to disable.
         */
        idlePingInterval: number;
    }

    /**
     * Indicates the desired auto resume behavior.
     */
    export enum EAutoResume {
        /**
         * Auto resume functionality will be disabled.
         */
        disabled,
        /**
         * Can resume automatically even if they are idle.
         */
        idle,
        /**
         * Can only resume automatically if they are not yet idle.
         */
        notIdle
    }

    export const defaultOptions: Partial<IModuleOptions> = {
        enabled: true,
        idle: 1200, // 20 minutes
        timeout: 300, // 5 minutes
        autoResume: EAutoResume.idle,
        interrupts: DEFAULT_INTERRUPT_SOURCES,
        pingInterval: 0, // disabled
        idlePingInterval: 0 // disabled
    };
}
